import {
  Avatar,
  Box,
  Button,
  Chip,
  CircularProgress,
  Grid,
  IconButton,
  Switch,
  Typography,
} from '@mui/material'
import React, { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import ConfirmationBox from 'src/Component/ConfirmationBox'
import SimpleModal from 'src/Component/SimpleModal'
import { useGetParkByIdQuery } from 'src/api/manageParksApi'
import { AppDispatch } from 'src/store'
import { startPageLoader, stopPageLoader } from 'src/store/features/common/commonSlice'
import useEditHook from './useEditHook'
import InputField from 'src/Component/InputField'
import { Controller } from 'react-hook-form'
import FileInput from 'src/Component/FileInput'
import editIconRedBg from 'src/assets/icons/editIconRedBg.png'
import SimpleDropdown from 'src/Component/SimpleDropdown'
import { PRODUCT_TYPES } from 'src/utils/constants'
import {
  useGetCategoriesByTypeQuery,
  useLazyGetCategoriesByTypeQuery,
} from 'src/api/manageProductsApi'
type EditModalProps = {
  id: number
  open: boolean
  onClose: () => void
  successCallback: () => void
  onDeleteClick: (id: number) => void
}
const EditModal = ({ id, open, onClose, successCallback, onDeleteClick }: EditModalProps) => {
  const {
    file,
    handleFileChange,
    control,
    errors,
    onSubmit,
    isLoadingEditPark,
    imageUrl,
    showUploadImage,
    handleShowUploadImage,
    product,
    watchState: { productType },
    resetCategory,
    handleChangeStatus,
  } = useEditHook({
    successCallback,
    id,
  })

  const [fetchCategories, { isFetching: isFetchingCategories, data: CATEGORIES = [] }] =
    useLazyGetCategoriesByTypeQuery()

  const handleProductTypeChangeCallBack = () => {
    resetCategory()
  }

  useEffect(() => {
    fetchCategories(productType)
  }, [productType])

  return (
    <Box>
      <SimpleModal open={open} onClose={onClose}>
        <form onSubmit={onSubmit}>
          <Box>
            <Grid container>
              <Grid xs={12} sm={6}>
                <Box>
                  {showUploadImage || !imageUrl ? (
                    <FileInput
                      type='image'
                      title='You can click me to upload files!'
                      discription='Support for  image file formats (.png, .jpeg)'
                      name='fileuplaod'
                      value={file}
                      onChange={handleFileChange}
                      showPreview
                    />
                  ) : (
                    <Box textAlign='center' position='relative' minHeight='50px'>
                      <img
                        src={imageUrl}
                        style={{
                          maxHeight: '200px',
                          objectFit: 'cover',
                        }}
                      />
                      <Box
                        sx={{
                          position: 'absolute',
                          right: 0,
                          bottom: 0,
                        }}
                      >
                        {' '}
                        <IconButton onClick={handleShowUploadImage}>
                          <img src={editIconRedBg} />
                        </IconButton>
                      </Box>
                    </Box>
                  )}
                </Box>
              </Grid>
              <Grid xs={12} sm={6} alignItems='center' display='flex'>
                <Typography variant='h2' p={2}>
                  {product?.title}
                </Typography>
              </Grid>
            </Grid>

            <Grid container mt={3}>
              <Grid xs={12} sm={12} md={8}>
                <Grid container>
                  <Grid xs={4}>
                    <Typography variant='h4'>Product ID</Typography>
                  </Grid>
                  <Grid xs={8}>
                    <Typography variant='h5'> {product?.id} </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid container mt={2}>
              <Grid xs={8}>
                <Grid container>
                  <Grid xs={4}>
                    <Typography variant='h4' component='p'>
                      Active/In-Active
                    </Typography>
                  </Grid>
                  <Grid xs={8}>
                    <Controller
                      name='isActive'
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <>
                          <Switch
                            color='error'
                            checked={field.value}
                            onChange={handleChangeStatus}
                          />
                          {!!errors.isActive && (
                            <Grid container justifyContent='right'>
                              <Typography variant='subtitle2' color='red' textAlign='right'>
                                {errors.isActive.message}
                              </Typography>
                            </Grid>
                          )}
                        </>
                      )}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid container >
              <Grid xs={12} sm={12} md={8} mb={2}>
                <Controller
                  name='title'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <InputField
                        name={field.name}
                        type='text'
                        label='Product Name'
                        placeholder='Enter product name'
                        value={field.value}
                        onChange={field.onChange}
                        // error={!!errors.title}
                        required
                      />
                      {!!errors.title && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.title.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>

            <Grid container>
              <Grid xs={12} sm={12} md={8} mb={2}>
                <Controller
                  name='productType'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <SimpleDropdown
                        required
                        label={'Product Type'}
                        id={field.name}
                        name={field.name}
                        value={field.value}
                        onChange={(props: any) => {
                          field.onChange(props)
                          handleProductTypeChangeCallBack()
                        }}
                        options={PRODUCT_TYPES?.map((type) => {
                          return {
                            value: type,
                            label: type,
                          }
                        })}
                        placeholder='Select product type'
                        // error={!!errors.productType}
                      />
                      {!!errors.productType && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.productType.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>

            <Grid container>
              <Grid xs={12} sm={12} md={8} mb={2}>
                <Controller
                  name='price'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <InputField
                        name={field.name}
                        type='number'
                        regex={/[^0-9]*$/}
                        label='Amount per unit'
                        placeholder='Enter amount'
                        value={field.value === 0 ? '' : field.value}
                        onChange={field.onChange}
                        // error={!!errors.price}
                        required
                      />
                      {!!errors.price && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.price.type === 'typeError'
                              ? 'Price shoule be number'
                              : errors.price.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>

            <Grid container>
              <Grid xs={12} sm={12} md={8} mb={2}>
                <Controller
                  name='unit'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <InputField
                        name={field.name}
                        type='text'
                        label='Unit'
                        placeholder='Enter unit'
                        value={field.value}
                        onChange={field.onChange}
                        // error={!!errors.unit}
                        required
                      />
                      {!!errors.unit && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.unit.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>

            <Grid container>
              <Grid xs={12} sm={12} md={8} mb={2}>
                <Controller
                  name='category'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <SimpleDropdown
                        required
                        disabled={isFetchingCategories}
                        label={'Category'}
                        id={field.name}
                        name={field.name}
                        value={field.value === 0 ? '' : field.value}
                        onChange={field.onChange}
                        options={CATEGORIES?.map((category) => {
                          return {
                            value: category.id,
                            label: category.name,
                          }
                        })}
                        placeholder='Select category'
                        // error={!!errors.category}
                      />
                      {!!errors.category && (
                        <Grid container justifyContent='right'>
                          {' '}
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.category.message}
                          </Typography>{' '}
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>

            <Grid container>
              <Grid xs={12} sm={12} md={8} mb={2}>
                <Controller
                  name='description'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <InputField
                        name={field.name}
                        type='text'
                        label='Description'
                        multiline
                        rows={4}
                        placeholder='Enter description'
                        value={field.value}
                        onChange={field.onChange}
                        // error={!!errors.description}
                        required
                      />
                      {!!errors.description && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.description.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>

            <Button
              variant='contained'
              color='secondary'
              type='submit'
              disabled={isLoadingEditPark}
            >
              {isLoadingEditPark ? <CircularProgress size={25} color='error' /> : 'SAVE'}
            </Button>

            <Button
              onClick={() => onDeleteClick(id)}
              sx={{ marginLeft: '20px' }}
              variant='contained'
              color='primary'
              type='button'
            >
              DELETE
            </Button>
          </Box>
        </form>
      </SimpleModal>
    </Box>
  )
}

export default EditModal
